export default __webpack_public_path__ + "static/media/StupendousSound_00.5979e523.png";